module.exports = __webpack_public_path__ + "static/1_2_000-a5f57810135f892e795c2f5a15ddaab8.jpg";